module.exports = __webpack_public_path__ + "static/img/Bachelor_010177.b4f2dd5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010177.jpg
// module id = 119
// module chunks = 0